var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('AllHeader',{attrs:{"title":"行业动态"}}),_c('NewsList',{attrs:{"fenlei":"行业动态"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }